import React, { useEffect, useState } from 'react'
import { Container } from './styled'
import { useTranslation } from 'react-i18next'
import InternalHeader from '../../general/internalHeader/view'
import CommunityListItem from '../communityListItem/view'
import { searchPublicCommunities } from 'api'
import { Grid, Typography, Box } from '@mui/material'
import NoResultsPlaceholder from 'components/organisms/noResultsPlaceholder/view'
import { useNavigate } from 'react-router'
import { useProfile } from 'context';
import noAvatar from '../../../../assets/images/no-avatar.png'
import { getAvatarUrl, getBackgroundUrl } from '../../../../api/utils'
import coworking from 'assets/images/coworking.jpg'


const CommunityExplore = () => {
  const { t } = useTranslation()
  const { profile } = useProfile()
  const [communities, setCommunities] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  function searchCommunities(search = '') {
    setLoading(true)
    searchPublicCommunities({ search }).then(r => {
      setCommunities(r.communities || r.groups || [])
    })
    .catch(console.error)
    .finally(() => setLoading(false))
  }

  function handleSearchChange(event) {
    const value = event.target.value
    setSearchTerm(value)
    // Search as user types (debounced effect will be added via useEffect)
  }

  function navigateCommunity(item) {
    const slug = item?.slug || item?.group?.slug
    navigate(`/community/${slug}`)
  }

  useEffect(() => {
    // Debounce search
    const timer = setTimeout(() => {
      searchCommunities(searchTerm)
    }, 300)
    return () => clearTimeout(timer)
  }, [searchTerm])

  const avatar = getAvatarUrl(profile, noAvatar)
  const background = getBackgroundUrl(profile, coworking)

  return (
    <Container>
      {/* Community header with search */}
      <InternalHeader 
        title="Explore Communities" 
        subtitle="Discover and join communities that match your interests" 
        avatar={avatar} 
        background={background}
        showSearch={true}
        searchValue={searchTerm}
        onSearchChange={handleSearchChange}
        searchPlaceholder="Search by name or description..."
      />

      <Box sx={{ maxWidth: 1200, margin: '0 auto', padding: 3 }}>
        {/* Results count */}
        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          {loading ? 'Searching...' : `${communities.length} ${communities.length === 1 ? 'community' : 'communities'} found`}
        </Typography>

        {/* Communities Grid */}
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {loading ? (
            <Grid item xs={12}>
              <Typography align="center" sx={{ py: 4 }}>
                Loading...
              </Typography>
            </Grid>
          ) : communities?.length === 0 ? (
            <Grid item xs={12}>
              <NoResultsPlaceholder 
                firstSentence={searchTerm ? 'No communities found' : 'No public communities available'} 
                lastSentence={searchTerm ? 'Try a different search term' : 'Check back later for new communities'} 
              />
            </Grid>
          ) : (
            communities.map((item, index) => (
              <Grid item xs={6} sm={4} md={3} key={index}>
                <CommunityListItem 
                  group={item} 
                  selectCommunity={() => navigateCommunity(item)} 
                />
              </Grid>
            ))
          )}
        </Grid>
      </Box>
    </Container>
  )
}

CommunityExplore.propTypes = {}

export default CommunityExplore
